import { createContext, useContext } from 'react';

import { CollaborationV1CollaborativeDocumentState } from '@spotify/confidence-graphql';

import { useCollaborativeDocumentSuspense } from '../../hooks/useCollaborativeDocumentSuspense';

type CollaborativeDocumentContextValue = ReturnType<
  typeof useCollaborativeDocumentSuspense
> & {
  isPublished: boolean;
};

const CollaborativeDocumentContext =
  createContext<CollaborativeDocumentContextValue | null>(null);

export const CollaborativeDocumentProvider = ({
  documentName,
  children,
}: {
  documentName: string;
  children: React.ReactNode;
}) => {
  const result = useCollaborativeDocumentSuspense({
    name: documentName,
  });
  const { collaborativeDocument } = result;

  return (
    <CollaborativeDocumentContext.Provider
      value={{
        ...result,
        isPublished:
          collaborativeDocument.state ===
          CollaborationV1CollaborativeDocumentState.Published,
      }}
    >
      {children}
    </CollaborativeDocumentContext.Provider>
  );
};

export const useCollaborativeDocumentContext = () => {
  const context = useContext(CollaborativeDocumentContext);

  if (!context) {
    throw new Error(
      'useCollaborativeDocumentContext must be used within CollaborativeDocumentProvider',
    );
  }

  return context;
};
